import React, { Fragment } from 'react';

const railOuterStyle = {
    position: 'absolute',
    width: '103%',
    height: 23,
    transform: 'translate(-2%, -50%)',
    cursor: 'pointer',
    marginTop: 27
  }
  
  const railInnerStyle = {
    position: 'absolute',
    width: '100%',
    height: 3,
    transform: 'translate(0%, -50%)',
    borderRadius: 1,
    pointerEvents: 'none',
    backgroundColor: '#B6B9BF',
    marginTop: 27
  }

  const railStartStyle = {
    position: 'absolute',
    width: 7,
    height: 7,
    transform: 'translate(-75%, -50%)',
    borderRadius: 3,
    backgroundColor: '#B6B9BF',
    marginTop: 27,
    pointerEvents: 'none',
  }

  const railEndStyle = {
    position: 'absolute',
    width: 7,
    height: 7,
    transform: 'translate(25%, -50%)',
    borderRadius: 3,
    backgroundColor: '#B6B9BF',
    marginTop: 27,
    right: 0,
    pointerEvents: 'none',
  }

export default function SliderRail({ getRailProps }) {
    return (
      <Fragment>
        <div style={railOuterStyle} {...getRailProps()} />
        <div style={railInnerStyle} />
        <div style={railStartStyle} />
        <div style={railEndStyle} />
      </Fragment>
    )
  }